export function getCompanyLogoUrl(companyData) {
  const url =
    companyData?.logoUrl ||
    companyData?.logo ||
    companyData?.logoURL ||
    companyData?.imageUrl ||
    companyData?.branding?.logoUrl ||
    '';
  return String(url || '').trim();
}

export function getEmployeeCustomPhotoUrl(employee) {
  return String(employee?.photoURL || employee?.photoUrl || '').trim();
}

/** Employee photo when set, otherwise the company logo. */
export function getEmployeeAvatarUrl(employee, companyData) {
  const photoURL = getEmployeeCustomPhotoUrl(employee);
  if (photoURL) return photoURL;
  return getCompanyLogoUrl(companyData);
}

export function isEmployeeCompanyLogoAvatar(employee, companyData) {
  return !getEmployeeCustomPhotoUrl(employee) && Boolean(getCompanyLogoUrl(companyData));
}
